import { render, staticRenderFns } from "./myAccount.vue?vue&type=template&id=a7051542&scoped=true"
import script from "./myAccount.vue?vue&type=script&lang=js"
export * from "./myAccount.vue?vue&type=script&lang=js"
import style0 from "./myAccount.vue?vue&type=style&index=0&id=a7051542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7051542",
  null
  
)

export default component.exports